import { Heart } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-charcoal text-white section-padding">
      <div className="container-max">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Couple Info */}
          <div className="text-center md:text-left">
            <h3 className="font-serif text-2xl font-bold mb-4 flex items-center justify-center md:justify-start gap-2">
              <Heart className="w-6 h-6 text-sage-light" fill="currentColor" />
              Doreen & Edwin
            </h3>
            <p className="text-white/80 leading-relaxed">
              Thank you for being part of our love story. We can't wait to celebrate with you on our special day!
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <div className="space-y-2">
              <button 
                onClick={() => document.getElementById('details')?.scrollIntoView({ behavior: 'smooth' })}
                className="block w-full text-white/80 hover:text-sage-light transition-colors"
              >
                Wedding Details
              </button>
              {/* <button 
                onClick={() => document.getElementById('rsvp')?.scrollIntoView({ behavior: 'smooth' })}
                className="block w-full text-white/80 hover:text-sage-light transition-colors"
              >
                RSVP
              </button> */}
              <button 
                onClick={() => document.getElementById('travel')?.scrollIntoView({ behavior: 'smooth' })}
                className="block w-full text-white/80 hover:text-sage-light transition-colors"
              >
                Travel Info
              </button>
            </div>
          </div>

          {/* Contact & Social */}
          <div className="text-center md:text-right">
            <h4 className="font-semibold text-lg mb-4">Stay Connected</h4>
            <div className="flex justify-center md:justify-end gap-4 mb-4">
              

            </div>
            <p className="text-white/80 text-sm">
              Questions? Email us at<br />
              <a href="mailto:doreenandedwin0418@gmail.com" className="text-sage-light hover:underline">
                doreenandedwin0418@gmail.com
              </a>
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 text-center">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © 2026 Doreen & Edwin. Made with love for our special day.
            </p>
            <div className="text-sage-light font-medium">
              #DoreenAndEdwin2026
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
